import { render, staticRenderFns } from "./tx-loader.vue?vue&type=template&id=7576b737&"
import script from "./tx-loader.ts?vue&type=script&lang=ts&"
export * from "./tx-loader.ts?vue&type=script&lang=ts&"
import style0 from "./tx-loader.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports